import src from "IMAGE";
export default { src, width: 612, height: 356, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAAHklEQVR42s3KoQEAAAABMC/KPvB/5wNZWBsoZ8FBKK7rU0lzgAyuAAAAAElFTkSuQmCC"};
